/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.57"
        height="101.17"
        viewBox="0 0 95.57 101.17"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M47.78 31.93a1.27 1.27 0 0 1 1.21 1.17v8a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09v-8a1.25 1.25 0 0 1 1.28-1.3Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M57.49 39.86a1.24 1.24 0 0 1 1.25 1.23 1.27 1.27 0 0 1-1.12 1.25H38.04a1.25 1.25 0 0 1-.13-2.49h19.58ZM33.12 3.26v2.5h-4.35v6.88c0 3.6 1.19 5.07 4.19 5.3h.23l-.12 2.56c-4.47-.23-6.7-2.74-6.79-7.5V5.1a1.88 1.88 0 0 1 1.73-1.87h5.11ZM67.42 3.26a1.88 1.88 0 0 1 1.87 1.72v7.66c0 4.86-2.14 7.46-6.51 7.79l-.29.07-.13-2.5c3.1-.16 4.36-1.55 4.42-5V5.76h-4.29v-2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M60.49 0h-25.4a1.9 1.9 0 0 0-1.89 1.9v18a14.58 14.58 0 0 0 14.29 14.53h.32a14.59 14.59 0 0 0 14.56-14.58v-18A1.9 1.9 0 0 0 60.49 0ZM35.7 2.5h24.17v17.35a12.1 12.1 0 0 1-11.78 12.08h-.31A12.08 12.08 0 0 1 35.7 19.85Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M52.6 12.5a.67.67 0 0 0-.84-.44l-3.56 1.17V9.55a.66.66 0 0 0-.57-.73.65.65 0 0 0-.72.57.43.43 0 0 0 0 .16v3.68l-3.58-1.13a.68.68 0 0 0-.56 1.24h.16l3.56 1.13-2.2 3a.65.65 0 0 0 .35.85.66.66 0 0 0 .65-.09l2.2-3 2.21 3a.62.62 0 0 0 .87.16.64.64 0 0 0 .15-.89l-2.16-3 3.57-1.15a.69.69 0 0 0 .44-.85"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><path
          fill="#ffb81c"
          d="M47.54 8.4a1.16 1.16 0 0 1 1.14 1v3.1l2.92-.94a1.18 1.18 0 0 1 1.43.65v.12a1.2 1.2 0 0 1-.65 1.43h-.12l-2.91.94 1.8 2.47A1.16 1.16 0 0 1 51 18.7l-.1.08a1.14 1.14 0 0 1-1.53-.16l-.08-.09-1.8-2.43-1.8 2.48a1.14 1.14 0 0 1-1.5.32l-.1-.07a1.13 1.13 0 0 1-.32-1.5l.07-.11 1.79-2.47-2.9-.94a1.18 1.18 0 0 1-.76-1.31v-.13a1.16 1.16 0 0 1 1.35-.8h.13l2.91.94v-3a1.13 1.13 0 0 1 1-1.14Zm4.59 4.27a.24.24 0 0 0-.17-.13l-4.27 1.38V9.55a.15.15 0 0 0-.15-.15.14.14 0 0 0-.14.1v4.42l-4.22-1.37a.17.17 0 0 0-.22.12.18.18 0 0 0 .07.2l4.22 1.36-2.6 3.59a.14.14 0 0 0 0 .21.14.14 0 0 0 .17 0l2.6-3.59 2.61 3.59a.17.17 0 0 0 .21 0 .17.17 0 0 0 0-.17l-2.61-3.59 4.23-1.37a.19.19 0 0 0 .12-.16Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M80.99 54.42a1.27 1.27 0 0 1 1.25 1.08v8.42a1.25 1.25 0 0 1-1.25 1.18 1.23 1.23 0 0 1-1.21-1.09v-7.13H15.82v7a1.27 1.27 0 0 1-1.12 1.25h-.13a1.25 1.25 0 0 1-1.24-1.12v-8.38a1.27 1.27 0 0 1 1.16-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M47.78 48.6a1.26 1.26 0 0 1 1.25 1.12v6a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09v-6a1.23 1.23 0 0 1 1.23-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M14.57 71.44a8.17 8.17 0 1 0 8.17 8.17 8.17 8.17 0 0 0-8.17-8.17Zm0 2.5a5.67 5.67 0 1 1-5.66 5.68 5.67 5.67 0 0 1 5.66-5.68ZM21.36 91.1a7.81 7.81 0 0 1 7.8 7.55v1.22a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09v-1.1a5.32 5.32 0 0 0-5.08-5.3H7.79a5.3 5.3 0 0 0-5.3 5.08v1.19a1.25 1.25 0 0 1-1.28 1.22A1.23 1.23 0 0 1 0 100v-1.1a7.79 7.79 0 0 1 7.55-7.8ZM80.99 71.44a8.17 8.17 0 1 0 8.17 8.17 8.17 8.17 0 0 0-8.15-8.17Zm0 2.5a5.67 5.67 0 1 1-5.66 5.68 5.67 5.67 0 0 1 5.66-5.68ZM87.78 91.1a7.8 7.8 0 0 1 7.79 7.55v1.22a1.25 1.25 0 0 1-1.19 1.31 1.24 1.24 0 0 1-1.31-1.18v-1.1a5.31 5.31 0 0 0-5.09-5.3H74.21a5.29 5.29 0 0 0-5.3 5.08v1.19a1.25 1.25 0 0 1-1.19 1.31 1.24 1.24 0 0 1-1.31-1.18v-1.1a7.79 7.79 0 0 1 7.58-7.8Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoPersonTournamentBracketWithTrophyIcon';

export default Icon;
